import { useState, useEffect, useRef } from "react";
import {
  FaChartLine,
  FaBullseye,
  FaClipboardCheck,
  FaBolt,
  // FaUserPlus,
  // FaSearch,
  FaFileInvoice,
  // FaExclamationTriangle,
  // FaBed,
  // FaFileMedical,
} from "react-icons/fa";
import {
  motion,
  useMotionValue,
  useTransform,
  animate,
} from "framer-motion";
import Trusted from "./Trusted";
const Content = () => {
      const stats = [
            {
      icon: <FaBolt className="text-[#106EE8] w-6 h-6" />,
      prefix: "",
      value: 20,
      suffix: "%",
      description: "Faster Consultation ",
    },
    {
      icon: <FaBullseye className="text-[#106EE8] w-6 h-6" />,
      prefix: "",
      value: 98,
      suffix: "%",
      description: "Model Efficiency",
    },
    {
      icon: <FaClipboardCheck className="text-[#106EE8] w-6 h-6" />,
      prefix: "Up to ",
      value:15,
      suffix: " minutes",
      description: "Time saving on each consultation ",
    },

        {
      icon: <FaChartLine className="text-[#106EE8] w-6 h-6" />,
      value: 30,
      prefix: "Up to ",
      suffix: "%",
      description: "Revenue Increase",
    }
  ];
  const solutions1 = [
  {
    icon: <FaFileInvoice />,
    title: "Pre-Consultation Assessment",
    description:
      "AI-led symptom investigation and history taking before the visit, so the GP starts with a clear, structured brief.",
    points: [
      "Symptom investigation",
      "History taking",
      "Pre-visit clinical brief",
    ],
  },
  {
    icon: <FaClipboardCheck />,
    title: "Scribe: Conversation Transcription and Note Generation",
    description:
      "Real-time scribing that turns the consultation into a transcript and a structured clinical note automatically.",
    points: [
      "Live conversation capture",
      "Transcript + structured note",
      "Less manual documentation",
    ],
  },
  {
    icon: <FaClipboardCheck />,
    title: "Risk Assessment",
    description:
      "Continuously checks for guideline misalignment and flags the GP when action or review is needed.",
    points: [
      "Guideline alignment checks",
      "GP alerts when needed",
      "Risk and safety flags",
    ],
  },
  {
    icon: <FaClipboardCheck />,
    title: "Post-Consultation Assistance",
    description:
      "Provides support after the consultation to ensure clarity, safety, and proper follow-up.",
    points: [
      "Patient follow-up Q&A",
      "Escalate to GP",
      "Clarify instructions safely",
    ],
  },
];

  // const solutions2 = [
  //   {
  //     icon: <FaFileMedical />,
  //     title: "Medical Audit",
  //     description:
  //       "Audit medical records to identify errors, improve documentation quality, and ensure compliance.",
  //   },
  //   {
  //     icon: <FaUserPlus />,
  //     title: "Patient Recruitment",
  //     description:
  //       "Identify patients potentially eligible for clinical trials based on medical records.",
  //   },
  //   {
  //     icon: <FaClipboardCheck />,
  //     title: "Medical Coding",
  //     description:
  //       "Optimize ICD-10 and CPT coding to increase revenue and reduce claim denials.",
  //   },
  //   {
  //     icon: <FaExclamationTriangle />,
  //     title: "Risk Flagging",
  //     description:
  //       "Automatically identify patients with clinical risk factors to enable proactive care.",
  //   },
  //   {
  //     icon: <FaBed />,
  //     title: "Bed Turnover",
  //     description:
  //       "Accelerate bed turnover by identifying discharge-ready patients and optimizing capacity.",
  //   },
  //   {
  //     icon: <FaSearch />,
  //     title: "Medical Search",
  //     description:
  //       "Get answers to complex clinical questions with AI-powered medical search.",
  //   },
  // ];

  const integrations = [
    { name: "Epic", image: "./img/epic.webp" },
    { name: "Google Drive", image: "./img/google_drive.webp" },
    { name: "Dropbox", image: "./img/sap.webp" },
    { name: "Notion", image: "./img/sharepoint.webp" },
    { name: "Google Drive", image: "./img/azure.webp" },
    { name: "Dropbox", image: "./img/aws.webp" },
    { name: "Notion", image: "./img/gcp.webp" },
    // add more integrations as needed
  ];
  return (
    <>
     
     <section className="bg-white text-black dark:bg-black dark:text-white py-16 px-6 w-full border-b-2 border-[#6B6B6B]">
          <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-gray-200/50 dark:bg-gray-900/50 border border-gray-700 rounded-lg p-6 flex flex-col items-center text-center hover:bg-gray-300 dark:hover:bg-gray-800 transition"
              >
                <div className="mb-3">{stat.icon}</div>

                <h3 className="text-2xl font-bold mb-1">
                  {stat.prefix}
                  <Counter value={stat.value} />
                  {stat.suffix}
                </h3>

                <p className="text-gray-700 dark:text-gray-400 text-sm">
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </section>
        {/* Trusted */}
        <Trusted />

        {/* Solutions Section */}
        <section className=" my-10 py-16 px-6 max-w-7xl mx-auto bg-white text-black dark:bg-black dark:text-white border-x-2  border-b-2 border-[#6B6B6B]">
          <p className="text-[#106EE8] font-semibold text-sm mb-2 text-center">
            Solutions
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center">
            Consultation Assistance Use-Cases

          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-12 w-full text-center font-medium">
            From revenue recovery to compliance validation, our AI automates the
            heavy lifting
            <br /> so your team can focus on what matters.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {solutions1.map((s, i) => (
              <div
                key={i}
                className="p-6 border rounded-lg hover:shadow-lg transition bg-gray-50 dark:bg-black"
              >
                <div className="flex items-center gap-2 text-[#106EE8] mb-3 text-xl">
  {s.icon}
  <h3 className="font-semibold">{s.title}</h3>
</div>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                  {s.description}
                </p>
                <ul className="list-disc pl-5 text-sm text-gray-700 dark:text-gray-300 mb-2">
                  {s.points && s.points.map((p, idx) => <li key={idx}>{p}</li>)}
                </ul>
                
              </div>
            ))}
          </div>
        </section>
        {/* Team Tools Section */}
        {/* <section className="py-16 px-6 max-w-7xl mx-auto border-x-2 border-b-2 border-[#6B6B6B]  bg-white text-black dark:bg-black dark:text-white ">
          <p className="text-[#106EE8] font-semibold text-sm mb-2 text-center">
            For Teams & Enterprises
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center">
            Powerful AI tools for your entire organization
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-12 w-full text-center font-medium">
            Transform your healthcare operations with AI-powered analytics,
            patient management, and clinical intelligence at scale.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 ">
            {solutions2.map((s, i) => (
              <div
                key={i}
                className="p-6 border rounded-lg hover:shadow-lg transition bg-gray-50 dark:bg-black hover:text-[#106EE8] hover:border-[#106EE8]"
              >
                <div className="text-[#106EE8] mb-3 text-xl">{s.icon}</div>
                <h3 className="font-semibold mb-2 ">{s.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {s.description}
                </p>
              </div>
            ))}
          </div>
        </section> */}
        {/* Integrations */}
        <section className="py-16 px-6 max-w-7xl mx-auto">
          <h3 className="text-[#106EE8] font-semibold text-xl mb-6 text-center">
            Integrations
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-4 items-center">
            {integrations.map((integration, idx) => (
              <div
                key={idx}
                className="p-4 border rounded-lg text-center bg-gray-100 dark:bg-black text-gray-800 dark:text-gray-200 flex items-center justify-center"
              >
                <img
                  src={integration.image} // image URL
                  alt={integration.name || `Integration ${idx + 1}`}
                  className="min-h-12 object-contain mx-auto"
                />
              </div>
            ))}
          </div>
        </section>
        <footer className="py-6 px-6 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-600 dark:text-gray-400">
          Don't miss the chance to scale your operations up to 8x
        </footer>
    </>
  )
}

export default Content


export function Counter({ value }) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.floor(latest));

  const ref = useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
        }
      },
      { threshold: 0.5 },
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (start) {
      const controls = animate(count, value, {
        duration: 2,
        ease: "easeOut",
      });

      return controls.stop;
    }
  }, [start, value,count]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
}
